import * as React from 'react';
import { UitkText } from 'uitk-react-text';
import { classNames } from 'uitk-react-utils';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkDateNumber } from '../ToolkitComponents/uitk-date-number.esm.js';
import styles from '../../uitk-calendar.css';
var DefaultDayTemplate = function (props) {
  var _a = props.day,
    isPast = _a.isPast,
    isPastMaxDate = _a.isPastMaxDate,
    isToday = _a.isToday,
    dateDay = _a.day,
    enablePastDates = props.enablePastDates,
    dayData = props.dayData;
  var dateText = dayData.dateText;
  var getClassNameList = classNames.bind(styles);
  var wrapperClassNames = getClassNameList('uitk-default-day-template');
  var getDateTextComponent = function () {
    return React.createElement(UitkLayoutFlexItem, null, dateText.textValue ? React.createElement(UitkText, {
      size: 100,
      weight: dateText.textWeight,
      theme: dateText.textTheme
    }, dateText.textValue) : React.createElement(UitkText, {
      spacing: "three"
    }, " "));
  };
  var getTheme = function () {
    if (isToday) {
      return 'today';
    }
    if (isPast && !enablePastDates || isPastMaxDate) {
      return 'muted';
    }
    return 'default';
  };
  return React.createElement(UitkLayoutFlex, {
    justifyContent: "center",
    alignItems: "center",
    direction: "column",
    blockSize: "full_size",
    className: wrapperClassNames
  }, React.createElement(UitkLayoutFlexItem, null, React.createElement(UitkDateNumber, {
    theme: getTheme(),
    disabled: isPast && !enablePastDates || isPastMaxDate
  }, dateDay)), dateText && getDateTextComponent());
};
DefaultDayTemplate.canClick = function (_dayData, day, enablePastDates) {
  return !day.isPast && !day.isPastMaxDate || enablePastDates && !day.isPastMaxDate;
};
DefaultDayTemplate.canSpan = function (_dayData, day, enablePastDates) {
  return !day.isPast && !day.isPastMaxDate || enablePastDates && !day.isPastMaxDate;
};
DefaultDayTemplate.getAriaLabel = function (_dayData, day, l10n, enablePastDates) {
  var isPast = day.isPast,
    isPastMaxDate = day.isPastMaxDate,
    localeDateString = day.localeDateString;
  return isPast && !enablePastDates || isPastMaxDate ? l10n.formatText('calendar.unavailable.a11yLabel', localeDateString) : localeDateString;
};
export { DefaultDayTemplate };